import * as immu from 'object-path-immutable'

// -----------------------------------------
// Drugs from index:substance for ids array
// -----------------------------------------
export function drugsByNames( list ) {

  return async ( dispatch, getState, api ) => {

    // Parse result
    const drugs = {}

    // Quality control
    if ( !list || Array.isArray( list ) == false || list.length == 0 ) {
      return drugs
    }

    // Transform into lookup
    const names = list.reduce( ( acc, cur ) => {
      if ( !!cur && cur.length >= 4 ) acc[ cur ] = `name.\\*:${cur}*`
      // if ( !!cur && cur.length < 4 ) acc[ cur ] = null
      return acc
    }, {} )

    // -------------------------------------------------------
    // Bugfix 2021-10-11: amphotericin_b is not recognized
    // -------------------------------------------------------
    // Also check for possible ids
    for ( const id of list ) {
      names[ `id-${id}` ] = `id:${id}`
    }

    const { meta, data } = await api.simple.find( {
      index: "substance",
      body: {
        query: {
          query_string: {
            query: Object.values( names ).join( " OR " )
          }
        }
      },
      size: 20
    } )

    if ( meta.code == 200 && Array.isArray( data ) ) {
      for ( const drug of data ) {
        drugs[ drug.id ] = {
          id: drug.id,
          name: drug.name,
          atc: drug.atc,
          form: drug.form,
          applw: drug.applw,
          alt: drug.alt || []
        }
      }
    } else {
      console.log( "Error: elastic.substanceByNames failed" )
      if ( process.env.NODE_ENV == "develop" ) {
        console.log( meta )
        console.log( data )
      }
    }

    return drugs

  }

}